



















































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  experienceSourceListApi,
  experienceSourceListInter,
} from "@/api/statistics";
import { sourceTypeSelectListApi } from "@/api/storeManagement";
import { dateFormat } from "@/utils/timeFormat";
import json2csv from "json2csv";
import { roundNumbers } from "@/utils/roundNumbers";
@Component({
  components: {},
})
export default class extends Vue {
  @Prop() timeDate!: string[];
  tableData: any = [];
  currentSortOption: any = {
    order: "descending",
    prop: "",
  };
  searchInfo: {
    source_id?: number;
  } = {};
  sourceList: any = [];
  paginationData: any = [];
  exporting: boolean = false;
  @Watch("timeDate", { immediate: false, deep: true })
  onChangeValue() {
    this.getList({
      start: this.timeDate[0],
      end: this.timeDate[1],
    });
  }
  created() {
    this.getList({
      start: this.timeDate[0],
      end: this.timeDate[1],
    });
    this.handleSourceList();
  }
  handleSourceList() {
    sourceTypeSelectListApi().then((res: any) => {
      if (res.error_code === 0) {
        this.sourceList = res.data.list;
      }
    });
  }
  handleSearch() {
    this.getList({
      start: this.timeDate[0],
      end: this.timeDate[1],
    });
  }
  getList(val: { start: string; end: string }) {
    const params: experienceSourceListInter = {
      start_date: val.start,
      end_date: val.end,
    };
    if (this.searchInfo.source_id) {
      params.source_id = this.searchInfo.source_id;
    }
    experienceSourceListApi(params).then((res: any) => {
      if (res.error_code === 0) {
        let num = 1;
        res.data.list.map((it: any) => {
          it.ranking = num++;
          it.finish_rate = roundNumbers(it.finish_rate);
          it.transform_rate = roundNumbers(it.transform_rate);
          it.transform_amount = roundNumbers(it.transform_amount);
          it.transform_amount_1vn = roundNumbers(it.transform_amount_1vn);
          it.transform_amount_1v1 = roundNumbers(it.transform_amount_1v1);
        });
        this.tableData = res.data.list;
        this.paginationData = res.data.list;
      }
    });
  }
  handleSortChange(val: any) {
    this.currentSortOption = {
      order: val.order,
      prop: val.prop,
    };
    this.tableData = this.sortList(this.tableData);
    let n = 0;
    this.tableData.map((it: any, ind: any) => {
      n += 1;
      it.ranking = n;
    });
  }
  sortList(val: any[]) {
    const copy = [...val];
    copy.sort((a: any, b: any) => {
      return (
        Number(b[this.currentSortOption.prop]) -
        Number(a[this.currentSortOption.prop])
      );
    });
    copy.map((it: any, ind: any) => {
      it.ind = ind + 1;
    });
    if (this.currentSortOption.order === "ascending") {
      copy.reverse();
    }
    return copy;
  }
  handleChange(v: any, id: any) {
    const goExperience = this.$router.resolve({
      name: "experience",
      query: {
        val: v,
        s_time: this.timeDate[0],
        e_time: this.timeDate[1],
        from: "experience",
        source_id: id,
      },
    });
    window.open(goExperience.href, "_blank");
  }
  // 导出
  handleExport() {
    if (this.exporting) {
      return false;
    }
    this.exporting = true;
    const date: any = new Date().getTime();
    const dateTime = dateFormat("YYYYmmddHHMMSS", date);
    const endThree = String(date).slice(-3, date.length);
    try {
      const result = json2csv.parse(
        [
          {
            "source.name": "来源渠道",
            invited_count: "预约体验数",
            invited_count_1vn: "1vN体验数",
            invited_count_1v1: "1v1体验数",
            finish_count: "完成体验数",
            finish_rate: "完成体验率",
            transform_count: "体验转化数",
            transform_rate: "体验转化率",
            transform_amount: "转化金额 (元)",
            transform_amount_1vn: "1vN金额 (元)",
            transform_amount_1v1: "1v1金额 (元)",
          },
          ...this.paginationData,
        ],
        {
          fields: [
            "source.name",
            "invited_count",
            "invited_count_1vn",
            "invited_count_1v1",
            "finish_count",
            "finish_rate",
            "transform_count",
            "transform_rate",
            "transform_amount",
            "transform_amount_1vn",
            "transform_amount_1v1",
          ],
          header: false,
        }
      );
      // 非IE浏览器
      const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
      // 创建a标签下载
      const link = document.createElement("a");
      link.href = encodeURI(csvContent);
      link.download = "来源渠道体验数据" + dateTime + endThree;
      (".csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // 5秒导出间隔
      setTimeout(() => {
        this.exporting = false;
      }, 5000);
    } catch (err: any) {
      this.$message({
        type: "error",
        message: err.toString(),
      });
    }
  }
}
